import { render, staticRenderFns } from "./IncomeComponent.vue?vue&type=template&id=f9de97a0&scoped=true"
import script from "./IncomeComponent.vue?vue&type=script&lang=js"
export * from "./IncomeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9de97a0",
  null
  
)

export default component.exports